import type { ConfigType } from '@plone/registry';

const LISTING_BLOCK = 'listing';

const restrictListing = (
  blocksConfig: Record<string, any> | undefined,
  visited = new WeakSet<object>(),
) => {
  Object.values(blocksConfig ?? {}).forEach((block) => {
    if (!block || visited.has(block)) return;
    visited.add(block);

    if (block.id === LISTING_BLOCK) block.restricted = true;
    if (Array.isArray(block.allowedBlocks)) {
      block.allowedBlocks = block.allowedBlocks.filter(
        (id: string) => id !== LISTING_BLOCK,
      );
    }

    restrictListing(block.blocksConfig, visited);
  });
};

export const updateListingConfig = (config: ConfigType) => {
  restrictListing(config.blocks.blocksConfig);
  return config;
};

export default updateListingConfig;
